import { Page, parseToNumberOrNull } from '@touche-lts/panel-ui/dist'
import { ProductsFilterDTO, ProductsTableEntityDTO } from 'models'
import { FetchOptions } from 'services'
import { ProductsTableSearchProps, ProductsTableSortProps } from '.'
import { PaginationSearchBase } from '..'
import {
  initialProductsTablePaginationProps,
  initialProductsTableSearchProps,
  productsTableNeedTimeoutProps
} from './products-table-base.utils'

export class ProductsTableBase extends PaginationSearchBase<
  ProductsTableSortProps,
  ProductsTableSearchProps,
  ProductsTableEntityDTO
> {
  constructor () {
    super({
      initialPaginationProps: initialProductsTablePaginationProps,
      initialSearchProps: initialProductsTableSearchProps,
      needTimeoutProps: productsTableNeedTimeoutProps
    })
  }

  public handleSearchResult = (data: Page<ProductsTableEntityDTO>): void => {
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content)
  }

  public getPageQueryParams = (
    resetPageNumber: boolean
  ): FetchOptions['pageQueryParams'] => {
    return {
      page: resetPageNumber ? 0 : this.pagination.page,
      size: this.pagination.size,
      sortDirection: this.pagination.sortDirection,
      sortProp: this.pagination.sortProp
    }
  }

  public get productFilter (): Partial<ProductsFilterDTO> {
    return {
      categoryName: null,
      departmentName: this.searchProps.departmentName,
      endDate: this.searchProps.addedOnPeriod
        ? this.searchProps.addedOnPeriod.end.toISOString()
        : null,
      id: parseToNumberOrNull(this.searchProps.id),
      maxRevenue: this.searchProps.maxRevenue,
      minRevenue: this.searchProps.minRevenue,
      maxSKUs: this.searchProps.maxSKUs,
      maxSold: this.searchProps.maxSold,
      maxStock: this.searchProps.maxSold,
      minSKUs: this.searchProps.minSKUs,
      minSold: this.searchProps.minSold,
      minStock: this.searchProps.minStock,
      productName: this.searchProps.productName,
      startDate: this.searchProps.addedOnPeriod
        ? this.searchProps.addedOnPeriod.start.toISOString()
        : null,
      storeName: this.searchProps.storeName
    }
  }
}
